import React from "react";

const Select = (props) =>  (
  <div className="choose">
    <label htmlFor={ props.name } className="select">{ props.title }</label>
      <select name={ props.name } onChange={ (e) => { props.setFunction( e.target.value ); }  } required={ props.required } defaultValue="">

        <option disable="true" value="">{ props.default_option }</option>
        { props.options && props.options.map( (item, index) => (
          <>
            { item.title && 
              <option key={index} value={ item.name }>{ item.title }</option>
            }
          </>
        ))}
      
      </select>
  </div>
)

export default Select